import axios from 'axios'
import store from '@/store'

const API_BASE_URL = process.env.VUE_APP_API_URL || 'https://clubtest.intrare.app'

function getHeaders () {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Token ${store.getters.getToken}`
  }
}

export const tournamentsAPI = {
  list (params) {
    return axios.get(`${API_BASE_URL}/tournaments/`, {
      headers: getHeaders(),
      params
    })
  },

  get (id) {
    return axios.get(`${API_BASE_URL}/tournaments/${id}/`, {
      headers: getHeaders()
    })
  },

  create (data) {
    return axios.post(`${API_BASE_URL}/tournaments/`, data, {
      headers: getHeaders()
    })
  },

  update (id, data) {
    return axios.patch(`${API_BASE_URL}/tournaments/${id}/`, data, {
      headers: getHeaders()
    })
  },

  delete (id) {
    return axios.delete(`${API_BASE_URL}/tournaments/${id}/`, {
      headers: getHeaders()
    })
  },

  register (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/register_player/`,
      data,
      { headers: getHeaders() }
    )
  },

  registerByAdmin (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/register_by_admin/`,
      data,
      { headers: getHeaders() }
    )
  },

  registerCCSLPUser (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/inscribir-ccslp/`,
      data,
      { headers: getHeaders() }
    )
  },

  registerGuest (tournamentId, data) {
    return axios.post(
      `${API_BASE_URL}/tournaments/${tournamentId}/inscribir-user/`,
      data,
      { headers: getHeaders() }
    )
  },

  getRegistrations (tournamentId) {
    return axios.get(
      `${API_BASE_URL}/tournaments/${tournamentId}/registrations/`,
      { headers: getHeaders() }
    )
  },

  cancelRegistration (registrationId) {
    return axios.post(
      `${API_BASE_URL}/tournament-registrations/${registrationId}/cancel/`,
      {},
      { headers: getHeaders() }
    )
  },

  myRegistrations (params) {
    return axios.get(`${API_BASE_URL}/tournament-registrations/`, {
      headers: getHeaders(),
      params
    })
  }
}
